import { cache } from "@serophin/browser";
import { initClient } from "@serophin/nottldr-shared";
import type { CacheProvider } from "@serophin/shared";
import { hasSession } from "./session";

const noStorage: CacheProvider = {
  set: () => {},
  get: () => null,
  remove: () => {},
  removeByPrefix: () => {},
  keys: () => [],
  clear: () => {},
};

/** The browser's client: cached in localStorage, and signed out until a token exists. */
export const initBrowserClient = (): void => {
  initClient(cache, { isSignedIn: hasSession });
};

/** The server render's client: no storage and no session. */
export const initServerClient = (): void => {
  initClient(noStorage, { isSignedIn: () => false });
};
